import { RegisterParams, SignUpParams } from './Types';

import { validateSetStage, validateSetState } from '../Validator';

export const validateRegisterParams = (params: RegisterParams): void => {
  validateSetState(params.setState);
};

export const validateSignUpParams = (params: SignUpParams): void => {
  validateSetStage(params.setStage);
  validateSetState(params.setState);
};
